export * from "./collateProjectVariables";


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/utils/ProjectVariableCollation/index.ts